import '@Pages/GeoMMM/Results/Components/ModelAccuracyGradient.scss';

export const ModelAccuracyGradient = () => (
  <>
    <div className='model-accuracy-gradient-container'>
      <div className='gradient-title'>
        <div>Model Accuracy</div>
      </div>
      <div className='gradient-bar'>
        <div className='tick tick-high' />
        <div className='label label-high'>High</div>
        <div className='tick tick-mid' />
        <div className='label label-mid'>Median</div>
        <div className='tick tick-low' />
        <div className='label label-low'>Low</div>
      </div>
    </div>
    <div className='dma-note-holder'>
      <div className='dma-note'>
        <div className='blank-rectangle' />
        <div className='dma-note-text'>Not included in model training</div>
      </div>
    </div>
  </>
);
